module.exports = __webpack_public_path__ + "static/media/Nursing.d3ca0ab8.png";